import { Injectable } from "@angular/core";
import { AfericaoCatraca } from "@tivic-team/manager-ts/dist/mob/entities/concessao/afericao-catraca.entity";
import { AfericaoCatracaDTO, AfericaoCatracaListDTO } from "app/model/dtos/mob/afericao-catraca.dto";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";
import { environmentv3 } from "src/environments/environmentv3";
@Injectable()
export class AfericaoCatracaController{
    constructor() {}

    async create(afericaoCatracaDTO: AfericaoCatracaDTO): Promise<AfericaoCatracaDTO> {
        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/afericao/catracas',
                    environment: environment
                }),
                data: new JSONData(afericaoCatracaDTO)
            }),
            new HttpResponse(
                new AfericaoCatracaDTO()
            )
        );
        return await quark.call();
    }

    async find(filtros?: IFilter): Promise<Array<AfericaoCatracaDTO>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/afericao/catracas',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<AfericaoCatracaDTO>()
            )
        );
        return await quark.call();
    }

    async buscar(filtros?: IFilter): Promise<AfericaoCatracaListDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/afericaocatracas/',
                    environment: environmentv3,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new AfericaoCatracaListDTO()
            )
        );
        return await quark.call();
    }

    async buscarLacracao(filtros?: IFilter): Promise<AfericaoCatracaListDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/afericaocatracas/lacracao',
                    environment: environmentv3,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new AfericaoCatracaListDTO()
            )
        );
        return await quark.call();
    }

    async getRelatorio(filtros?: IFilter): Promise<Blob>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/afericaocatracas/relatorio',
                    environment: environmentv3,
                    filter: filtros
                }),
                responseType: 'Blob'
            }),
            new HttpResponse(
                new Blob
            )
        );
        return await quark.call();
    }

    async get(cdAfericaoCatraca: number): Promise<AfericaoCatracaDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/afericao/catracas/:cdAfericaoCatraca',
                    environment: environment,
                    pathParams: new JSONData({ cdAfericaoCatraca: cdAfericaoCatraca})
                }),
            }),
            new HttpResponse(
                new AfericaoCatracaDTO()
            )
        );

        return await quark.call();
    }

    async update(afericaoCatracaDTO: AfericaoCatracaDTO): Promise<AfericaoCatracaDTO>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/afericao/catracas/:cdAfericaoCatraca',
                    environment: environment,
                    pathParams: new JSONData({ cdAfericaoCatraca: afericaoCatracaDTO.cdAfericaoCatraca})
                }),
                data: new JSONData(afericaoCatracaDTO)
            }),
            new HttpResponse(
                new AfericaoCatracaDTO()
            )
        );
        return await quark.call();
    }

    async getDataUltimaAfericao(nrPrefixo: number): Promise<AfericaoCatraca>{
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/afericao/catracas/dataPosterior/:nrPrefixo',
					environment: environment,
					pathParams: new JSONData({nrPrefixo: nrPrefixo})
				}),
			}),
			new HttpResponse(
				new AfericaoCatraca()
			)
		);
		return await quark.call();
	}
}